<template>

<core-modal v-on:close="onClose" :nopadding="true" :loading="is.loading" :is-large="true">

	<template v-slot:head>

		Updates & News

	</template>

	<template v-slot:default>

		<div class="notifications">

			<div class="notification" :data-type="notification.type" v-for="notification in notifications" :key="notification.id" v-tooltip="'Click to read more'" v-on:click="onNotificationClick(notification)">

				<div class="notification-image" :class="{'no-image': !notification.image}" :style="{backgroundImage: 'url(' + notification.image + ')'}">

					<div class="notification-icon"><i :class="icons[notification.type]" /></div>

				</div>

				<div class="notification-info">

					<div class="notification-info-title">{{ notification.name }}</div>

					<div class="notification-info-tags">
						<span class="is-type">{{ subtitle[notification.type] }}</span>
					</div>

					<div class="notification-info-date">{{ notification.date | fromNow }}</div>

				</div>

			</div>

		</div>

	</template>

</core-modal>

</template>

<script>

export default {

	data: function() {
	
		return {
			is: {
				loading: true
			},
			icons: {
				1: 'fa-solid fa-rocket-launch',
				2: 'fa-solid fa-rotate',
				3: 'fa-solid fa-check-to-slot',
				4: 'fa-solid fa-flask',
				5: 'fa-solid fa-message-code',
				6: 'fa-brands fa-patreon',
			},
			subtitle: {
				1: 'Update',
				2: '',
				3: 'Feature Voting',
				4: 'Early Access',
				5: 'Developer Blog',
				6: 'Patreon'
			}
		}
	},

	created: function() {
	
		if (this.notifications.length) {
		
			this.is.loading = false

		} else {
		
			this.load()
		
		}
	
	},

	computed: {
	
		notifications: function() {
		
			return this.$store.getters['api/app/notifications']
		
		}
	
	},

	methods: {

		load: function() {
		
			this.$store.dispatch('api/app/notifications').then(function(json) {
			
				this.$store.commit('api/app/notifications', json.notifications)

				this.$store.commit('session/notifications', 0)

				this.is.loading = false
			
			}.bind(this))
		
		},

		onNotificationClick: function(notification) {
		
			this.$emit('close')

			this.$pubsub.$emit('open.modal', {
				id: 'appUpdate',
				notification: notification
			})

		},

		onClose: function() {

			this.$emit('close')

		}

	}

}

</script>

<style scoped>

.notifications {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-gap: 20px;
	padding: 0px 20px;
	width: calc(100% - 40px);
}

.is-mobile .notifications {
	grid-template-columns: 1fr;
	padding: 0px 10px;
	width: calc(100% - 20px);
}

.notification {
	display: grid;
	grid-template-columns: 1fr;
	border-radius: 4px;
	cursor: pointer;
}

.notification:hover > * {
	border-color: #ccc;
}

.notification-image {
	height: 160px;
	background-position: 50% 50%;
	background-size: cover;
	border: 1px solid #eee;
	border-bottom: 0px;
	border-radius: 4px 4px 0px 0px;
}

.notification-image.no-image {
	border: 0px;
}

.notification-icon {
	position: absolute;
	right: 4px;
	top: 4px;
	width: 40px;
	height: 40px;
	color: #fff;
	font-size: 16px;
	line-height: 40px;
	text-align: center;
	border-radius: 4px;
}

.notification-image.no-image .notification-icon {
	left: 0px;
    top: 0px;
    width: 100%;
    height: 160px;
    line-height: 160px;
    font-size: 64px;
    border-radius: 4px 4px 0px 0px
}

.notification-info {
	padding: 10px;
	display: grid;
	grid-gap: 4px;
	grid-template-columns: 1fr 1fr;
	border: 1px solid #eee;
	border-radius: 0px 0px 4px 4px;
}

.notification-info-title {
	font-size: 16px;
	font-weight: 500;
	color: #333;
	grid-column: span 2;
	overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.notification-info-date {
	font-size: 12px;
	color: #333;
	line-height: 16px;
	text-align: right;
}

.notification-info-tags {
	gap: 4px;
	display: flex;
}

.notification-info-tags span {
	display: inline-block;
	padding: 2px 4px;
	border-radius: 4px;
	text-transform: lowercase;
	color: #333;
	background-color: #ddd;
	font-weight: 300;
	font-size: 12px;
}

.notification-info-tags span.is-type {
	color: #fff;
	font-weight: 500;
}

.notification[data-type="1"] .notification-icon,
.notification[data-type="1"] .notification-info-tags span.is-type {
	background-color: #f6c86c;
	color: #012b39;
}

.notification[data-type="3"] .notification-icon,
.notification[data-type="3"] .notification-info-tags span.is-type {
	background-color: #43A047;
}

.notification[data-type="4"] .notification-icon,
.notification[data-type="4"] .notification-info-tags span.is-type {
	background-color: #4881bb;
}

.notification[data-type="5"] .notification-icon,
.notification[data-type="5"] .notification-info-tags span.is-type {
	background-color: #7C4DFF;
}

.notification[data-type="6"] .notification-icon,
.notification[data-type="6"] .notification-info-tags span.is-type {
	background-color: #1A1F36;
}

</style>